const safePow = Math.pow(10, 20);

export function exerciseRandomSeed(randomSeed, salt) {
    let invertedSalt = `${salt}`.split('').reverse().join('');
    let result = randomSeed + parseFloat(`0.${invertedSalt}`);

    if (result >= 1) {
        result = (result * safePow - 1 * safePow) / safePow;
    }

    return result;
}

export function shuffle(sequence, seed) {
    let array = sequence.slice();
    let m = array.length;
    let i;
    seed = parseFloat(seed);
    // While there remain elements to shuffle…
    while (m) {
        // Pick a remaining element…
        i = Math.floor(random(seed) * m--);

        // And swap it with the current element.
        [array[m], array[i]] = [array[i], array[m]];
        ++seed;
    }

    return array;
}

function random(seed) {
    const x = Math.sin(seed) * 10000;
    return x - Math.floor(x);
}
